import { useState } from 'react'

import { RootState, useStore } from '../../../application/store/store'
import { useDashboardUseCase } from '../../../application/useCases/useDashboard'
import { useDocumentUseCase } from '../../../application/useCases/useDocuments'
import { formatDataToGraphPoints } from '../../components/graph/graph.helpers'
import { TUseAnalytics } from '../../components/statistic/statistic.types'

export const useAnalytics = (props: TUseAnalytics) => {
  const { energyGraphPoints, selectedPlant } = props
  const setDocuments = useStore((state: RootState) => state.setDocuments)
  const setSalesRevenue = useStore((state: RootState) => state.setSalesRevenue)
  const { getDocumentListByPlantWithCount, getDocumentListByUserWithCount } = useDocumentUseCase()
  const { getSalesRevenue } = useDashboardUseCase()

  const [loaders, setLoaders] = useState({
    documents: false,
    revenue: false,
  })

  const productionData = formatDataToGraphPoints(energyGraphPoints)

  const fetchDocuments = async () => {
    setLoaders((prevState) => ({ ...prevState, documents: true }))
    const documentsData = selectedPlant
      ? getDocumentListByPlantWithCount(
          selectedPlant.code_centrale,
          { pageIndex: 0, pageSize: 5 },
          null,
          [{ id: 'displayName', desc: true }]
        )
      : getDocumentListByUserWithCount({ pageIndex: 0, pageSize: 5 }, null, [
          { id: 'displayName', desc: true },
        ])
    await documentsData
      .then(({ data }) => setDocuments(data))
      .catch((error) => console.error('Error fetching documents data in dashboard:', error))
      .finally(() => {
        setLoaders((prevState) => ({ ...prevState, documents: false }))
      })
  }

  // Fetch revenue data
  const fetchSalesRevenue = async (startDate: number, endDate: number) => {
    setLoaders((prevState) => ({ ...prevState, revenue: true }))
    await getSalesRevenue(startDate, endDate, selectedPlant)
      .then((data) => {
        setSalesRevenue(data)
      })
      .catch((error) => {
        console.error('Error fetching dashboard data:', error)
      })
      .finally(() => {
        setLoaders((prevState) => ({ ...prevState, revenue: false }))
      })
  }

  return {
    productionData,
    analyticsDataLoader: loaders,
    fetchSalesRevenue,
    fetchDocuments,
  }
}
